/**
     * @desc 查询用户报价的NFT列表
用于我的报价页面，返回NFT作品详细信息，包含挂单信息和最高报价信息和我的报价信息
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/trading/getMyBids', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/trading/getMyBids', params);
}
